import { Routes, Route } from "react-router-dom";

import List from "./list";
import View from "./view";

export default function Users() {
  return (
    <Routes>
      <Route path="/:id" Component={View} />
      <Route path="/" Component={List} />
    </Routes>
  );
}
